import http from "@/axios/http-common";

export interface PrioritasFlag {
  key: string;
  label: string;
}

/**
 * Tanda prioritas perawat per register (badge merah PasienFlyingBar):
 * risiko jatuh tinggi / nyeri berat / EWS > 5 (atau Code Blue).
 */
class StatusPrioritas {
  async getByRegister(reg: string | number): Promise<PrioritasFlag[]> {
    try {
      const response = await http.getData(`/register/${reg}/status-prioritas`);
      return response.data?.data ?? [];
    } catch (e) {
      // badge bersifat non-kritis — jangan ganggu halaman dengan alert
      return [];
    }
  }
}

export default new StatusPrioritas();
